import { configureStore } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'
import { routerMiddleware } from 'connected-react-router'

import createReducer from './reducers'
import history from './utils/history'

import type { Action, ThunkAction } from '@reduxjs/toolkit'

const preloadedState = {}

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
})

export const store = configureStore({
  reducer: createReducer(),
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'web3/connectWallet/fulfilled',
          'earn/getStakingData/fulfilled',
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: [],
        // Ignore these paths in the state
        ignoredPaths: ['web3', 'earn'],
      },
    }).concat(routerMiddleware(history)),
  enhancers: [sentryReduxEnhancer],
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
